import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import Button from '../../components/botonservicios';
import TestButton from '../../components/boton';
import {ServicesContainer, ServicesHero, ServicesGrid, ServiceCard, ServiceImage, ServiceContent, servicesData} from './estilosServices';


function Services() {
  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };
  
  return (
    <ServicesContainer>
      <Helmet>
        <title>Servicios de diseño y desarrollo digital personalizados | Juanfra Hernández</title>
        <meta name="description" content="Explora servicios a medida en diseño, desarrollo web y estrategia digital. Trabajo contigo para crear soluciones únicas que generan resultados." />
        <link rel="canonical" href="https://juanfrahernandez.es/servicios" />
      </Helmet>

      <ServicesHero
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <video autoPlay muted loop playsInline>
          <source src="https://videos.pexels.com/video-files/28561463/12421438_2560_1440_30fps.mp4" type="video/mp4" />
        </video>
        <motion.div {...fadeInUp}>
          <h1>Servicios Digitales para hacer crecer tu negocio</h1>
          <p>Nuestro equipo ofrece soluciones integrales en desarrollo web, diseño digital, 
            SEO y marketing digital, diseñadas para transformar tu presencia online y alcanzar 
            tus objetivos. Descubre cómo podemos ayudarte a destacar en el mundo digital.</p>
         <Button contenido="Quiero una solucion para mi negocio" destino="/contacto" />
        </motion.div>
      </ServicesHero>

      <ServicesGrid>
        {servicesData.map((service, index) => (
          <ServiceCard
            key={service.id}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.2 }}
          >
            <ServiceImage>
              <img src={service.image} alt={service.title} />
            </ServiceImage>
            <ServiceContent>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul>
                {service.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
              <div style={{ marginTop: '1rem' }}>
                <TestButton contenido="Más información" destino="/contacto" />
              </div>
            </ServiceContent>
          </ServiceCard>
        ))}
      </ServicesGrid>
    </ServicesContainer>
  );
}

export default Services;